module.exports = __webpack_public_path__ + "img/iconExtra2.41f03d94.png";